import {
    makeStyles,
} from 'app/tss'

const muiTableCellBorderColor = '#E0E0E0'

const useStyles = makeStyles()((theme) => {
    return {
        cardContent: {
            '&&': {
                marginTop: theme.spacing(3),
            },
        },
        table: {
            paddingTop: theme.spacing(2),
        },
        enumInput: {
            '& .MuiTypography-root': {
                padding: '0px !important',
            },
        },
        numberInput: {
            '& ': {
                textAlign: 'right',
                '.MuiTypography-root': {
                    padding: '0px !important',
                },
            },
        },
        tableCellHead: {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            borderRight: `1px solid ${muiTableCellBorderColor}`,
            borderTop: `1px solid ${muiTableCellBorderColor}`,
            ':first-of-type': {
                borderLeft: `1px solid ${muiTableCellBorderColor}`,
            },
            padding: `${theme.spacing(1)} !important`,
        },
        tableCell: {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            borderRight: `1px solid ${muiTableCellBorderColor}`,
            ':first-of-type': {
                borderLeft: `1px solid ${muiTableCellBorderColor}`,
            },
            padding: `${theme.spacing(1)} !important`,
        },
    }
})

export default useStyles
